import React from "react";
import { View, StyleSheet } from "react-native";
import { Option, Title, InputBox } from "../../accessories/accessories";
import CustomText from "../../accessories/CustomText";
import CustomTextInput from "../../accessories/CustomTextInput";
import { web } from "../../accessories/Platform";
import { log } from "../../accessories/CommonFunctions";

const CreditScore = ({ detailsArr, handleOptionPress }) => {
  detailsArr["subFields"] = detailsArr["subFields"]?.filter((e) => e !== null);
  const typeTwoFields =
    detailsArr["subFields"]?.length > 0 ? detailsArr["subFields"] : [];

  return (
    <>
      {detailsArr["type"] === -1 ? (
        <View>{detailsArr["bodyContent"]}</View>
      ) : (
        <View>
          <Title text={detailsArr["Title"]} />
          {detailsArr["bodyText"] && detailsArr["bodyText"]}
          <View>
            <View
              style={
                detailsArr["widthOption"] !== undefined
                  ? { flexDirection: "row", justifyContent: "space-around" }
                  : { flex: 1 }
              }
            >
              {detailsArr["Options"]?.map((item, index) => (
                <Option
                  autoFocus={index == 0}
                  key={index}
                  style={
                    detailsArr["widthOption"] !== undefined
                      ? { width: detailsArr["widthOption"] }
                      : {}
                  }
                  type={item["type"]}
                  text={item["text"]}
                  value={item["value"] === detailsArr["ColumnValue"]}
                  onPress={() => handleOptionPress(item["value"])}
                />
              ))}
            </View>
          </View>
          {typeTwoFields?.length > 0 && (
            <View>
              {typeTwoFields?.map((item, index) => (
                <View key={index}>
                  <Title text={item["Title"]} />
                  {item["label"] !== "Down Payment" ? (
                    <InputBox
                      keyboardType={item["keyboardType"]}
                      maxLength={item["maxLength"]}
                      forceValidation={item["forceValidation"]}
                      isCurrency={item["isCurrency"]}
                      label={item["label"]}
                      placeholder={item["placeholder"] || item["label"]}
                      onBlur={() =>
                        item["onBlur"] !== undefined
                          ? item["onBlur"]()
                          : () => {}
                      }
                      onChangeText={(text) => {
                        try {
                          handleOptionPress(text, true, index);
                        } catch (e) {
                          log("Error from  ====> ", e);
                        }
                      }}
                      value={item["ColumnValue"]?.toString()}
                    />
                  ) : (
                    <>
                      <View style={{ flex: 1, flexDirection: "row" }}>
                        <View
                          style={[
                            styles.inputBoxContainer,
                            {
                              borderColor: "gray",
                              width: "100%",
                            },
                          ]}
                        >
                          <CustomText bold={true} style={styles.inputBoxLabel}>
                            {item["label"] || ""}
                          </CustomText>
                          <CustomTextInput
                            onChangeText={(text) =>
                              handleOptionPress(
                                text,
                                true,
                                index,
                                item["field"][0]["ColumnName"]
                              )
                            }
                            value={
                              item["field"][0]["ColumnValue"]?.toString() || ""
                            }
                            onBlur={() => item["field"][0]["onBlur"]()}
                            placeholder={item["placeholder"] || item["label"]}
                            keyboardType={"default"}
                            style={[
                              styles.inputBox,
                              { width: "63%", marginRight: 10 },
                            ]}
                            autoCapitalize={"none"}
                          />
                          <CustomTextInput
                            onChangeText={(text) =>
                              handleOptionPress(
                                text,
                                true,
                                index,
                                item["field"][1]["ColumnName"]
                              )
                            }
                            value={
                              item["field"][1]["ColumnValue"]?.toString() || ""
                            }
                            onBlur={() => item["field"][1]["onBlur"]()}
                            placeholder={item["placeholder"] || item["label"]}
                            keyboardType={"default"}
                            style={[styles.inputBox, { width: "30%" }]}
                            autoCapitalize={"none"}
                          />
                          <CustomText
                            style={{
                              color: "#999",
                              fontSize: 14,
                              marginTop: 5,
                              marginLeft: 3,
                            }}
                            bold={true}
                          >
                            %
                          </CustomText>
                        </View>
                      </View>
                    </>
                  )}
                </View>
              ))}
            </View>
          )}
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  iconButtonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 25,
    height: 45,
    paddingVertical: 10,
    paddingHorizontal: 10,
    marginTop: 8,
    paddingTop: web ? 5 : null,
    alignSelf: "flex-start",
    padding: 30,
  },
  iconButtonText: {
    fontSize: 18,
    color: "#fff",
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      // outlineWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
    },
  },
});

export default CreditScore;
